export default {
	props: {},

	mounted() {},

	data() {
		return {};
	},

	computed: {},

	methods: {
		showTopLoader() {
			this.$refs.topLoader.open();
		},

		hideTopLoader() {
			this.$refs.topLoader.close();
		},

		onAuthRequired() {
			this.$router.push('/');
		},
	},

	watch: {},
};
